import { SVGAttributes } from "react";

export const GlobeIcon = (
  props: SVGAttributes<SVGElement> & { size: "small" | "regular" }
) => {
  if (props.size === "small") {
    return (
      <svg
        width={17}
        height={16}
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.003 16a8 8 0 000-16 8 8 0 100 16zm0-14a6 6 0 010 12 6 6 0 110-12z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.002 16c2.44 0 4-3.638 4-8s-1.56-8-4-8C5.56 0 4 3.637 4 8c0 4.363 1.56 8 4.002 8zM9.205 3.444c.502 1.172.798 2.802.798 4.556s-.296 3.384-.798 4.556C8.785 13.533 8.312 14 8.002 14c-.311 0-.785-.467-1.204-1.444C6.296 11.384 6 9.754 6 8s.296-3.384.798-4.556C7.218 2.467 7.691 2 8.002 2c.31 0 .784.467 1.203 1.444z"
          fill="currentColor"
        />
        <path d="M14 7a1 1 0 110 2H2a1 1 0 010-2h12z" fill="currentColor" />
      </svg>
    );
  } else {
    return (
      <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.003 21.997C17.523 21.997 22 17.522 22 12s-4.476-9.997-9.997-9.997c-5.523 0-10 4.475-10 9.997s4.477 9.997 10 9.997zM19.435 11a7.5 7.5 0 00-3.507-5.39c.594 1.499.96 3.363 1.05 5.39h2.457zm0 2a7.5 7.5 0 01-3.507 5.39c.594-1.499.96-3.363 1.05-5.39h2.457zm-4.96-2c-.093-1.805-.44-3.453-.97-4.692-.524-1.22-1.115-1.803-1.503-1.803-.389 0-.98.583-1.504 1.803-.53 1.239-.877 2.887-.971 4.692h4.949zm-4.948 2h4.949c-.095 1.805-.44 3.453-.972 4.692-.523 1.22-1.114 1.803-1.502 1.803-.389 0-.98-.583-1.504-1.803-.53-1.239-.877-2.887-.971-4.692zm-2.502-2c.09-2.027.456-3.89 1.05-5.389A7.498 7.498 0 004.568 11h2.457zm-2.457 2h2.457c.09 2.027.456 3.89 1.05 5.389A7.498 7.498 0 014.568 13z"
          fill="currentColor"
        />
      </svg>
    );
  }
};
GlobeIcon.displayName = "GlobeIcon";
